module.exports = __webpack_public_path__ + "static/media/logo.af70b7e6.svg";